export function checkRolesByRole(role, actions) {
  if (!role || !Array.isArray(role.actions)) {
    return actions.map(() => false);
  }

  return actions.map((action) => role.actions.includes(action));
}

// Hook versiyonu — store’dan otomatik rol alır
export function useCheckRoles(actions) {
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  return checkRolesByRole(userInfo?.role, actions);
}
